import React, { Fragment } from "react";
import styled from "styled-components";
import moment from "moment";
import {
  LeadRequirement,
  RequirementStatus,
} from "../../../core/api/models/requirement";
import { decodeHtmlEntities } from "../../../utils/common";

const PreviewContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const Section = styled.div`
  display: flex;
  flex-direction: column;
`;

const Label = styled.div`
  min-width: 195px;
`;

const Value = styled.div`
  white-space: pre-wrap;
`;
const RequirementDetails: React.FC<{
  requirement?: LeadRequirement;
  versions?: LeadRequirement[];
  onEdit?: () => void;
}> = (props) => {
  const { requirement } = props;
  return (
    <Fragment>
      <div className="row mx-0 h-100">
        <div className="col-12 px-0">
          <div className="pb-5">
            <PreviewContainer>
              <Section>
                <div className="container-fluid py-2 top-0 zIndex-99">
                  <div className="row align-items-center px-1">
                    <div className="col-auto ml-0 mt-1 mt-md-0 pl-0">
                      <label className="font-base mb-3 pb-1 font-weight-semibold">
                        Location Information
                      </label>
                    </div>
                    {(props?.versions?.length ||
                      requirement?.status === RequirementStatus.Approved) && (
                        <div className="col-auto ml-auto mt-1 mt-md-0">
                          <span className="bg-white d-inline-block mr-2">
                            <button
                              onClick={props.onEdit}
                              className="btn btn-outline-secondary px-4 font-normal font-weight-bold py-2 rounded"
                            >
                              Edit
                            </button>
                          </span>
                        </div>
                      )}
                  </div>
                </div>

                <div className="border-bottom py-2 font-normal d-flex">
                  <Label className="py-1 text-muted">City:</Label>
                  <Value className="py-1 font-weight-semibold">
                    {requirement?.cityDetails?.cityName ?? "-"}
                  </Value>
                </div>
                <div className="border-bottom py-2 font-normal d-flex">
                  <Label className="py-1 text-muted">
                    Preferred Locations:
                  </Label>
                  <Value className="py-1 font-weight-semibold">
                    {requirement?.preferredLocationDetails?.length
                      ? requirement?.preferredLocationDetails
                        ?.map((x) => decodeHtmlEntities(x.cityLocName))
                        ?.join("\n")
                      : "-"}
                  </Value>
                </div>
                <div className="border-bottom py-2 font-normal d-flex">
                  <Label className="py-1 text-muted">Micro Markets:</Label>
                  <Value className="py-1 font-weight-semibold">
                    {requirement?.microMarketDetails?.length
                      ? requirement?.microMarketDetails
                        ?.map((x) => decodeHtmlEntities(x.cityZoneName))
                        ?.join("\n")
                      : "-"}
                  </Value>
                </div>
                <div className="border-bottom py-2 font-normal d-flex">
                  <Label className="py-1 text-muted">Property Type:</Label>
                  <Value className="py-1 font-weight-semibold">
                    {requirement?.propertyTypeDetails?.propertyTypeName
                      ? decodeHtmlEntities(
                        requirement?.propertyTypeDetails?.propertyTypeName
                      )
                      : "-"}
                  </Value>
                </div>
                <div className="border-bottom py-2 font-normal d-flex">
                  <Label className="py-1 text-muted">Project Type:</Label>
                  <Value className="py-1 font-weight-semibold">
                    {requirement?.projectTypeDetails
                      ? decodeHtmlEntities(requirement?.projectTypeDetails?.map?.((pType: any) => " " + pType.propertyTypeName ).toString())
                      : "-"}
                  </Value>
                </div>
              </Section>

              <Section>
                <label className="font-base mb-3 pb-1 font-weight-semibold mt-4">
                  Additional Property Information
                </label>
                <div className="border-bottom py-2 font-normal d-flex">
                  <Label className="py-1 text-muted">Intent:</Label>
                  <Value className="py-1 font-weight-semibold">
                    {requirement?.leadDetails?.leadIntent?.name || "-"}
                  </Value>
                </div>
                <div className="border-bottom py-2 font-normal d-flex">
                  <Label className="py-1 text-muted">Seats:</Label>
                  <Value className="py-1 font-weight-semibold">
                    {requirement?.minSeats || requirement?.maxSeats
                      ? `${requirement?.minSeats ?? ""} -  ${requirement?.maxSeats ?? ""
                      }`
                      : "-"}
                  </Value>
                </div>

                {(requirement?.propertyTypeDetails?.propertyTypeName === "Business Center & Co-working Space" ||
                  requirement?.projectTypeDetails?.some((pType: any) => pType.propertyTypeName === "Business Center & Co-working Space")) &&
                  <div className="border-bottom py-2 font-normal d-flex">
                    <Label className="py-1 text-muted">
                      Facility Type:
                  </Label>
                  <Value className="py-1 font-weight-semibold">
                    {requirement?.facilityTypeDetails?.facilityType
                      ? decodeHtmlEntities(
                        requirement?.facilityTypeDetails?.facilityType
                      )
                      : "-"}
                  </Value>
                </div>}

                <div className="border-bottom py-2 font-normal d-flex">
                  <Label className="py-1 text-muted">Budget(Per Sq. Ft.):</Label>
                  <Value className="py-1 font-weight-semibold">
                    {requirement?.minPrice || requirement?.maxPrice
                      ? `₹ ${requirement?.minPrice ?? ""} - ₹ ${requirement?.maxPrice ?? ""
                      }`
                      : "-"}
                  </Value>
                </div>
                <div className="border-bottom py-2 font-normal d-flex">
                  <Label className="py-1 text-muted">Sq.Ft. Area:</Label>
                  <Value className="py-1 font-weight-semibold">
                    {requirement?.minArea ?? ""} - {requirement?.maxArea ?? ""}
                  </Value>
                </div>

                {/* {requirement?.earliestMoveInDate && ( */}
                <div className="border-bottom py-2 font-normal d-flex">
                  <Label className="py-1 text-muted">
                    Earliest Move-in Date:
                  </Label>
                  <Value className="py-1 font-weight-semibold">
                    {requirement?.earliestMoveInDate
                      ? moment(requirement?.earliestMoveInDate).format(
                        "DD-MM-YYYY"
                      )
                      : "-"}
                  </Value>
                </div>
                {/* )} */}
                {/* {requirement?.earliestMoveInDate && ( */}
                <div className="border-bottom py-2 font-normal d-flex">
                  <Label className="py-1 text-muted">Last Move-in Date:</Label>
                  <Value className="py-1 font-weight-semibold">
                    {requirement?.earliestMoveInDate
                      ? moment(requirement?.lastMoveInDate).format("DD-MM-YYYY")
                      : "-"}
                  </Value>
                </div>
                {/* )} */}
                <div className="border-bottom py-2 font-normal d-flex">
                  <Label className="py-1 text-muted">Floor Preferences:</Label>
                  <Value className="py-1 font-weight-semibold">
                    {requirement?.floorPreferenceDetails?.length
                      ?
                      requirement?.floorPreferenceDetails
                        ?.slice()
                        ?.sort((a: { floorName: string }, b: { floorName: string }) => parseInt(a?.floorName, 10) - parseInt(b?.floorName, 10))
                        ?.map((x) => decodeHtmlEntities(x?.floorName))
                        ?.join("\n")
                      : "-"}
                  </Value>
                </div>
                {/* <div className="border-bottom py-2 font-normal d-flex">
                  <Label className="py-1 text-muted">Preferred Projects:</Label>
                  <Value className="py-1 font-weight-semibold">
                    {requirement?.preferedProjectDetails?.length
                      ? requirement?.preferedProjectDetails
                        ?.map((x) => decodeHtmlEntities(x.projectName))
                        ?.join("\n")
                      : "-"}
                  </Value>
                </div> */}
                {/* <div className="border-bottom py-2 font-normal d-flex">
                  <Label className="py-1 text-muted">
                    Preferred Developers:
                  </Label>
                  <Value className="py-1 font-weight-semibold">
                    {requirement?.preferedDeveloperDetails?.length
                      ? requirement?.preferedDeveloperDetails
                        ?.map((x) => decodeHtmlEntities(x.developer))
                        ?.join("\n")
                      : "-"}
                  </Value>
                </div> */}
                <div className="border-bottom py-2 font-normal d-flex">
                  <Label className="py-1 text-muted">
                    Construction Status:
                  </Label>
                  <Value className="py-1 font-weight-semibold">
                    {requirement?.constructionStatus?.length
                      ? requirement?.constructionStatus
                        ?.map(
                          (status) =>
                            status?.charAt(0)?.toUpperCase() +
                            status?.slice(1)?.replace(/([A-Z])/g, " $1")?.trim())?.join("\n")
                      : "-"}
                  </Value>
                </div>

                <div className="border-bottom py-2 font-normal d-flex">
                  <Label className="py-1 text-muted">
                    <div>Construction <span className="d-block">Completion Date:</span></div>
                  </Label>
                  <Value className="py-1 font-weight-semibold">
                    {requirement?.constructionCompletionDate
                      ? moment(requirement?.constructionCompletionDate).format(
                        "DD-MM-YYYY"
                      )
                      : "-"}
                  </Value>
                </div>

                <div className="border-bottom py-2 font-normal d-flex">
                  <Label className="py-1 text-muted">Interior Type:</Label>
                  <Value className="py-1 font-weight-semibold">
                    {requirement?.interiorType?.length
                      ? requirement?.interiorType
                        ?.map(
                          (status) =>
                            status?.charAt(0)?.toUpperCase() +
                            status?.slice(1)?.replace(/([A-Z])/g, " $1")?.trim())?.join("\n")
                      : "-"}
                  </Value>
                </div>

                <div className="border-bottom py-2 font-normal d-flex">
                  <Label className="py-1 text-muted">Include Grade C:</Label>
                  <Value className="py-1 font-weight-semibold">
                    {typeof requirement?.includeGradeC === "boolean"
                      ? requirement?.includeGradeC === true
                        ? "Yes"
                        : requirement?.includeGradeC === false && "No"
                      : "-"}
                  </Value>
                </div>

                <div className="border-bottom py-2 font-normal d-flex">
                  <Label className="py-1 text-muted">
                    <div>Include <span className="d-block">Lease Expiry Options:</span></div>
                  </Label>
                  <Value className="py-1 font-weight-semibold">
                    {typeof requirement?.includeLeaseExpiry === "boolean"
                      ? requirement?.includeLeaseExpiry === true
                        ? "Yes"
                        : requirement?.includeLeaseExpiry === false && "No"
                      : "-"}
                  </Value>
                </div>

                {/* <div className="border-bottom py-2 font-normal d-flex">
                  <Label className="py-1 text-muted">Car Parking:</Label>
                  <Value className="py-1 font-weight-semibold">
                    {requirement?.carParking === true
                      ? "Yes"
                      : requirement?.carParking === false
                        ? "No"
                        : "-"}
                  </Value>
                </div>
                <div className="border-bottom py-2 font-normal d-flex">
                  <Label className="py-1 text-muted">Power Backup:</Label>
                  <Value className="py-1 font-weight-semibold">
                    {requirement?.powerBackup === true
                      ? "Yes"
                      : requirement?.powerBackup === false
                        ? "No"
                        : "-"}
                  </Value>
                </div> */}
                {/* <div className="border-bottom py-2 font-normal d-flex">
                  <Label className="py-1 text-muted">Grade:</Label>
                  <Value className="py-1 font-weight-semibold">
                    {requirement?.grade !== undefined
                      ? requirement?.grade
                      : "-"}
                  </Value>
                </div> */}

                {/* <div className="border-bottom py-2 font-normal d-flex">
                  <Label className="py-1 text-muted">Amenities:</Label>
                  <Value className="py-1 font-weight-semibold">
                    {requirement?.amenitiyDetails?.length
                      ? requirement?.amenitiyDetails
                        ?.map((x) => decodeHtmlEntities(x.amenity))
                        ?.join("\n")
                      : "-"}
                  </Value>
                </div> */}

                <div className="border-bottom py-2 font-normal d-flex">
                  <Label className="py-1 text-muted">
                    Proposal Due By:
                  </Label>
                  <Value className="py-1 font-weight-semibold">
                    {requirement?.proposalDueBy
                      ? moment(requirement?.proposalDueBy)?.format("DD-MM-YYYY") : "-"}
                  </Value>
                </div>

                {/* <div className="border-bottom py-2 font-normal d-flex">
                  <Label className="py-1 text-muted">Proposal Format Type:</Label>
                  <Value className="py-1 font-weight-semibold">
                    {requirement?.proposalFormatType
                      ? requirement?.proposalFormatType
                      : "-"}
                  </Value>
                </div>
                <div className="border-bottom py-2 font-normal d-flex">
                  <Label className="py-1 text-muted">Proposal Type:</Label>
                  <Value className="py-1 font-weight-semibold">
                    {requirement?.proposalContentType
                      ? requirement?.proposalContentType
                      : "-"}
                  </Value>
                </div> */}
                <div className="border-bottom py-2 font-normal d-flex">
                  <Label className="py-1 text-muted">Forecast:</Label>
                  <Value className="py-1 font-weight-semibold">
                    {requirement?.forecast
                      ? requirement?.forecast
                      : "-"}
                  </Value>
                </div>
                <div className="border-bottom py-2 font-normal d-flex">
                  <Label className="py-1 text-muted">Certainity:</Label>
                  <Value className="py-1 font-weight-semibold">
                    {requirement?.certainity
                      ? requirement?.certainity
                      : "-"}
                  </Value>
                </div>

                {/* <div className="border-bottom py-2 font-normal d-flex">
                  <Label className="py-1 text-muted">Weight:</Label>
                  <Value className="py-1 font-weight-semibold">
                    {requirement?.weightage
                      ? requirement?.weightage
                      : "-"}
                  </Value>
                </div> */}

                <div className="border-bottom py-2 font-normal d-flex">
                    <Label className="py-1 text-muted">Special Requirements:</Label>
                    <Value className="py-1 font-weight-semibold">
                      {requirement?.specialRequirements !== undefined
                      ? requirement?.specialRequirements
                      : "-"}
                    </Value>
                </div>

                <div className="border-bottom py-2 font-normal d-flex">
                  <Label className="py-1 text-muted">Core Requirements:</Label>
                  <Value className="py-1 font-weight-semibold">
                    {!!requirement?.coreRequirements?.length
                      ? requirement?.coreRequirements?.join("\n")
                      : "-"}
                  </Value>
                </div>

                <div className="border-bottom py-2 font-normal d-flex">
                  <Label className="py-1 text-muted">Requirement Parameters:</Label>
                  <Value className="py-1 font-weight-semibold">
                    {!!requirement?.coreRequirementParameters?.length
                      ? requirement?.coreRequirementParameters?.join("\n")
                      : "-"}
                  </Value>
                </div>

                {/* <div className="border-bottom py-2 font-normal d-flex">
                  <Label className="py-1 text-muted">Special Requirements:</Label>
                  <Value className="py-1 font-weight-semibold">
                    {requirement?.specialRequirements !== undefined
                      ? requirement?.specialRequirements
                      : "-"}
                  </Value>
                </div> */}
              </Section>
            </PreviewContainer>
          </div>
        </div>
      </div>

      {/* <div className="modal-backdrop fade show"></div> */}
    </Fragment>
  );
};

export default RequirementDetails;
